import AutoLockAction from "@/enum/AutoLockAction";
import mainServerClient from "@/services/http/mainServerClient";

export interface AddressWarningSetting {
    id: number;

    companyId: number;

    autoAction: AutoLockAction;

    enable: boolean;

    /**过滤词 */
    keywords: string;
}

/**
 * 获取偷运费设置
 */
export function getAddressWarning() {
    return mainServerClient.get<AddressWarningSetting>("/address_warning_setting/get");
}

export interface SaveAddressWarningSettingParams {
    autoAction?: AutoLockAction;

    enable: boolean;

    keywords: string;
}

/**
 * 设置偷运费设置
 */
export function saveAddressWarning(params: SaveAddressWarningSettingParams) {
    return mainServerClient.post("/address_warning_setting/save", params);
}
